import styled, { css } from 'styled-components';

import { StyledVideoPlayback } from 'src/features/room/components/complex-room-box/components/video/video.styles';

export const StyledContainer = styled.div`
  display: block;
  margin: 1.6rem 0;
`;

export const StyledSectionContainer = styled.div`
  display: block;
  margin: 2.4rem 0;
`;

export const StyledButtonContainer = styled.div`
  margin-top: 2.4rem;
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const InputWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.6rem;
`;

export const InputContainer = styled.div`
  position: relative;
  flex: 1;
`;

export const StyledFormToggleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  margin: 1.6rem 0;
`;

export const ClearButton = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  color: ${({ theme }) => theme.colors.grey[400]};
  &:hover {
    color: ${({ theme }) => theme.colors.error.main};
  }
`;

export const StyledRoomPreviewVideo = styled(StyledVideoPlayback)`
  height: 49rem;
  width: 100%;
`;
const transitionStyles = css`
  &.video-preview-enter {
    opacity: 0;
  }
  &.video-preview-enter-active {
    opacity: 1;
    transition: opacity 500ms ease-in-out;
  }
  &.video-preview-exit {
    opacity: 1;
  }
  &.video-preview-exit-active {
    opacity: 0;
    transition: opacity 500ms ease-in-out;
  }
`;

export const TransitionStyledSectionContainer = styled(StyledSectionContainer)`
  ${transitionStyles}
`;
